import { render } from "./HomeGame.vue?vue&type=template&id=0fbfcc97&scoped=true"
import script from "./HomeGame.vue?vue&type=script&lang=js"
export * from "./HomeGame.vue?vue&type=script&lang=js"

import "./HomeGame.vue?vue&type=style&index=0&id=0fbfcc97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbfcc97"]])

export default __exports__